import { createContext, type ReactNode, useContext, useEffect, useRef } from "react";

type Flush = () => Promise<void>;
const AutosaveContext = createContext<Set<Flush> | null>(null);

/** A lifecycle action can flush all forms in its own card before committing. */
export function AutosaveBoundary({ children }: { children: ReactNode }) {
  const saves = useRef(new Set<Flush>());
  return <AutosaveContext.Provider value={saves.current}>{children}</AutosaveContext.Provider>;
}

export function useRegisterAutosave(flush: Flush) {
  const saves = useContext(AutosaveContext);
  useEffect(() => {
    saves?.add(flush);
    return () => {
      saves?.delete(flush);
    };
  }, [saves, flush]);
}

export function useFlushAutosaves(): Flush {
  const saves = useContext(AutosaveContext);
  return async () => {
    await Promise.all([...(saves ?? [])].map((flush) => flush()));
  };
}
